export default __webpack_public_path__ + "static/media/icon-play2.d7525bd5.svg";